import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { Box, Card, CardActionArea, CardContent, CardHeader, CardMedia, List, ListItemButton, ListItemText, Tooltip, Typography} from "@mui/material";

import { connect } from "react-redux";
import { getEventAttendances } from "../../../../actions/tmsActions";
import { getMyAttendances } from "../../../../reducers";
import DayJS from "react-dayjs";
import TMSAvatar from "../TMSAvatar";

const appCode = "C-TMS";


function MyEventsCard({ attendances, getMyAttendances }) {
    useEffect(() => {
        getMyAttendances(appCode, {start: new Date()});
    }, [getMyAttendances]);

    return (
        <Card className="card">
            <CardActionArea
                component={Link}
                to={"/tms/events"}
                centerRipple={true}
            >
                <CardHeader
                    disableTypography={true}
                    avatar={
                        <Tooltip title="View all events" arrow>
                            <TMSAvatar type="event" />
                        </Tooltip>
                    }
                    title={
                        <Typography component="h2" className="card-header-title">
                            Events
                        </Typography>
                    }
                    subheader={
                        <Typography component="span" className="card-header-subtitle">
                            {attendances?.length || 0} upcoming attendances
                        </Typography>
                    }
                />
            </CardActionArea>
            <CardContent>
                {!attendances?.length > 0 && (
                    <CardMedia
                        component="img"
                        height="240"
                        image="https://cdn.premierit.com/images/banners/themes/office/bnr-office-meeting-02.png"
                        alt="events"
                    />
                )}

                {attendances?.length > 0 && (
                    <Box className="card-content">
                        <List sx={{width: "100%", height: "350px", overflow: "auto"}}>
                            {attendances
                                .sort((a, b) => a.dateStart >= b.dateStart ? 1 : -1)
                                .map(({eventId, title, status, courseId, dateStart}) => (
                                    <ListItemButton
                                        alignItems="flex-start"
                                        key={eventId}
                                        component="div"
                                        disabled={status === "cancelled"}
                                    >
                                        <Link to={!!courseId ? `/tms/courses/${courseId}` : (!!eventId ? `/tms/events/${eventId}` : "")}>
                                            <ListItemText
                                                primary={title}
                                                secondary={
                                                    <DayJS format="DD MMM YYYY">
                                                        {dateStart}
                                                    </DayJS>
                                                }
                                            />
                                        </Link>
                                    </ListItemButton>
                                ))
                            }
                        </List>
                    </Box>
                )}
            </CardContent>
        </Card>
    );
}

MyEventsCard.propTypes = {
    getMyAttendances: PropTypes.func,
};

const mapStateToProps = (state) => ({
    attendances: getMyAttendances(state),
});

export default connect(mapStateToProps, {getMyAttendances: getEventAttendances})(MyEventsCard);
